import { render } from "./ButtonContainer.vue?vue&type=template&id=08ce7822"
import script from "./ButtonContainer.vue?vue&type=script&lang=js"
export * from "./ButtonContainer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__